const zhCN = {
  listName: '姓名',
  listIDNumber: '证件号',
  listPhone: '手机号',
  listExpiryDate: '有效期',
  listOperation: '操作',

  listAuthExpired: '已过期',
  listAuthPermanent: '永久授权',
  listAuthTerm: '至',

  listBtnEdit: '编辑',
  listBtnAuth: '修改授权',
  listBtnDelete: '删除',
  listBtnUnbind: '解绑小程序',
  listBtnBind: '绑定小程序',

  addBtn: '新增人员',
  bulkImportBtn: '批量导入',
  volumeLicenseesBtn: '批量设备授权',
  expiryDateBtn: '设置授权有效期',
  batchDeleteBtn: '批量删除',
  batchAuthBtn: '批量授权',

  searchTxt: '姓名/证件号',
  searchBtn: '搜索',

  QRCodeTitle: '人员二维码',
  QRCodeDesc: '扫描二维码通过身份验证后，即可绑定访客微信小程序，邀请访客！',
  QRCodeValidityDesc: '人员二维码有效期为5分钟！',
  getQRCodeFail: '获取二维码信息失败！',

  submitBtn: '提交',
  confirmBtn: '确定',
  cancelBtn: '取消',

  deleteWarning: '您确定要删除该人员？',
  deleteWarningDesc: '删除人员后，人员的所有授权将被取消！',

  batchDeleteWarning: 'return "您确定要删除当前选中的 " + count + " 人？"',
  batchDeleteWarningDesc: '删除这些人员后，人员的所有授权将被取消！',
  batchDeleteSuccess: 'return "成功删除 " + count + " 人员！"',
  batchDeleteFail: 'return "删除失败 " + count + " 人员！"',

  expiryDateModal: '设置授权有效期',
  expiryDateModalDesc: 'return "已选中 " + count + " 人"',

  expiryDateTxt: '有效期',
  dateStartTxt: '开始时间',
  dateEndTxt: '结束时间',
  comingWeekBtn: '未来一周',
  comingMonthBtn: '未来一个月',
  comingHalfYearBtn: '未来半年',
  comingYearBtn: '未来一年',

  expiryDateBlank: '请选择授权有效时间段，或选择永久授权！',
  expiryDateWarning: '授权时间段最多为一年，或选择永久授权！',

  permanentTxt: '永久授权',

  setExpiryDateSuccess: 'return count + " 人的授权时间设置成功！"',
  setExpiryDateFail: 'return count + " 人的授权时间设置失败！"',
  setExpiryDateRequestSuccess: '设置授权时间成功！',
  setExpiryDateRequestFail: '设置授权时间失败！',

  bulkImportTxt: '批量导入',
  improtInstructions: '导入说明',

  importHasSameData: '身份证相同数据',
  radioRecover: '覆盖',
  radioThrowErr: '提示错误',

  importFileTxt: '导入人员',
  importResultTxt: '导入结果',
  importSuccess: '导入成功：',
  importFail: '导入失败：',

  importFailErrFile: '导入失败记录详情.txt',
  downloadImportErrBtn: '下载错误信息',

  uploadFileBtn: '上传人员信息文件',
  uploadSuccess: '上传成功！',
  uploadFail: '上传失败！',

  unbindWarning: '您确定要解绑该业主的小程序？',
  unbindWarningDesc: '解绑后业主不能再邀请访客！',
  unbindSuccess: '解绑成功！',
  unbindFail: '解绑失败！'
}
const enUS = {
  listName: 'Name',
  listIDNumber: 'ID Number',
  listPhone: 'Phone',
  listExpiryDate: 'Expiry Date',
  listOperation: 'Operation',

  listAuthExpired: 'Expired',
  listAuthPermanent: 'Permanent',
  listAuthTerm: 'to',

  listBtnEdit: 'Edit',
  listBtnAuth: 'Authorize',
  listBtnDelete: 'Delete',
  listBtnUnbind: 'Unbind MiniProg',
  listBtnBind: 'Bind MiniProg',

  addBtn: 'Add',
  bulkImportBtn: 'Import',
  volumeLicenseesBtn: 'Volume Licensees',
  expiryDateBtn: 'Expiry Date',
  batchDeleteBtn: 'Batch Delete',
  batchAuthBtn: 'Batch Auth',

  searchTxt: 'Name / ID',
  searchBtn: 'Search',

  QRCodeTitle: 'Personnel QR code',
  QRCodeDesc: 'After scans the QR code to pass the authentication, can bind the visitor WeChat mini-program and invites the visitor!',
  QRCodeValidityDesc: 'Personnel QR code is valid for 5 minutes!',
  getQRCodeFail: 'Get QR code failed!',

  submitBtn: 'Submit',
  confirmBtn: 'Confirm',
  cancelBtn: 'Cancel',

  deleteWarning: 'Are you sure to delete this persone?',
  deleteWarningDesc: 'After deleting this person, all authorization of this person will be revoked!',
  deleteFail: 'Delete failed',

  batchDeleteWarning: 'return "Are you sure to delete "+ count +" persons selected?"',
  batchDeleteWarningDesc: 'After deleting those persons, all authorization of those persons will be revoked!',
  batchDeleteSuccess: 'return "Delete " + count + " persons successfully!"',
  batchDeleteFail: 'return "Delete " + count + " persons failed!"',

  expiryDateModal: 'Set Expiry Date',
  expiryDateModalDesc: 'return count + " people selected"',

  expiryDateTxt: 'Expiry Date',
  dateStartTxt: 'start',
  dateEndTxt: 'end',
  comingWeekBtn: 'coming week',
  comingMonthBtn: 'next 30 days',
  comingHalfYearBtn: 'next 6 months',
  comingYearBtn: 'a future year',

  expiryDateBlank: 'Expiry date can\'t be blank, or choose permanent!',
  expiryDateWarning: 'Expiry date is up to a year，or choose permanent!',

  permanentTxt: 'Permanent',

  setExpiryDateSuccess: 'return count + " people\'s expiry date was set successfully!"',
  setExpiryDateFail: 'return count + " people\'s expiry date was set failed!"',

  setExpiryDateRequestSuccess: 'Set expiry date successfully!',
  setExpiryDateRequestFail: 'Set expiry date failed!',

  bulkImportTxt: 'Bulk Import',
  improtInstructions: 'Instructions',

  importHasSameData: 'Has same data',
  radioRecover: 'Recover',
  radioThrowErr: 'Throw error',

  importFileTxt: 'Import File',
  importResultTxt: 'Result',
  importSuccess: 'Success to import: ',
  importFail: 'Fail to import: ',

  importFailErrFile: 'errorDetail.txt',
  downloadImportErrBtn: 'Download Import Error',

  uploadFileBtn: 'Upload File',
  uploadSuccess: 'upload successfully!',
  uploadFail: 'upload failed!',

  unbindWarning: 'Are you sure to unbind the WeChat mini-program of this person?',
  unbindWarningDesc: 'Visitors can no longer be invited after unbind!',
  unbindSuccess: 'Unbind successfully!',
  unbindFail: 'Unbind failed!'
}

export default { zhCN, enUS }
